import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { PromoAnagraphicComponent } from './anagraphic/promo-anagraphic.component';
import { PromoResultsComponent } from './results/promo-results.component';

@Component({
    selector: 'app-promo-analysis',
    templateUrl: './promo-analysis.component.html',
    styleUrls: ['./promo-analysis.component.css']
})
//Pagina 51 - Pagina 52
export class PromoAnalysisComponent implements OnInit {
    @ViewChild(PromoAnagraphicComponent) customerAnagraphic: PromoAnagraphicComponent;
    @ViewChild(PromoResultsComponent) customerResults: PromoResultsComponent;

    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    items: MenuItem[];
    oldData: any;
    activeIndex: number;
    translations: any = {};

    constructor(private translate: TranslateService,
                private svcAnalytics: AnalyticsService,
                private searchModelFactory: SearchToolbarModelFactoryService) {

        this.translate.get([
            'promo.analysis'
        ]).subscribe((t) => {
            this.translations = {
                page_title: t['promo.analysis']
            };
        });
    }

    ngOnInit() {
        this.activeIndex = 0;
        this.items = [];

        this.translate.get([
            'promo.anagraphic',
            'promo.results'
        ]).subscribe(t => {

            const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
            searchParams.svcAnalytics = this.svcAnalytics;
            searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
            searchParams.finestra = SearchToolbarFilterWindow.FiftyOne;
            searchParams.raggruppamento = SearchToolbarFilterGrouping.None;
            searchParams.disabledSections = [SearchToolbarSection.CardModes];

            this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
                this.searchModel = model;
            });

            this.items.push(
                {
                    label: t['promo.anagraphic'],
                    command: (event: any) => {
                        this.activeIndex = 0;
                    }
                },
                {
                    label: t['promo.results'],
                    command: (event: any) => {
                        this.activeIndex = 1;
                    }
                }
            );
        });
    }


    applyResult(data) {
        const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

        switch (this.activeIndex) {
            case 0:
                if (!isDataEquals) {
                    this.customerResults.resetData();
                }
                this.customerAnagraphic.searchValue(data);
                break;
            case 1:
                if (!isDataEquals) {
                    this.customerAnagraphic.resetData();
                }

                this.customerResults.searchValue(data);
                break;
        }

        this.oldData = { ...data };
    }



}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/analysis/promo-analysis.component.ts